/*###########################################################################
// Components
//#########################################################################*/

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
*/
import Alpine from 'alpinejs'
import header from "./_header"
import heroHome from "./_heroHome"

/* Register components */
Alpine.data('header', header)
Alpine.data('heroHome', heroHome)

Alpine.start()

/* Dynamic Components
//------------------*/

const dynamicComponents = () => {
	if (document.querySelector('.accordion')) {
		import('./_accordions')
	}

	if (document.querySelector('.copy-clipboard')) {
		import('./_copyClipboard')
	}

	if (document.querySelector('.marqueeScroll')) {
		import('./_marqueeScroll')
	}

	if (document.querySelector('.modal')) {
		import('./_modals')
	}

	if (document.querySelector('.responsive-video')) {
		import('./_responsiveVideo')
	}

	if (document.querySelector('.content')) {
		import('./_richTextCleanup')
	}

	if (document.querySelector('.newsSlider')) {
		import('./_sliderNews')
	}

	if (document.querySelector('.splitCtaImages')) {
		import('./_splitCtaImages')
	}

	if (document.querySelector('.sprigFilter')) {
		import('./_sprigFilter')
	}
}

if (document.readyState === 'complete') {
	dynamicComponents()
} else {
	window.addEventListener('load', () => {
		dynamicComponents()
	})
}

window.addEventListener('page-change', () => {
	dynamicComponents()
})

/* Standard Components
//------------------*/

import './_browserDetect'
import './_forms'
import './_header'
import './_imageScale'
import './_reveal'
